/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Level_ErrorInputs */

const en_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_hans1_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const pt_br2_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

const es_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const de_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const ru_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const it_usage_level_error = /** @type {(inputs: Usage_Level_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Usage_Level_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_level_error = /** @type {((inputs?: Usage_Level_ErrorInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Level_ErrorInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_level_error(inputs)
	if (locale === "pt-BR") return pt_br2_usage_level_error(inputs)
	if (locale === "es") return es_usage_level_error(inputs)
	if (locale === "fr") return fr_usage_level_error(inputs)
	if (locale === "de") return de_usage_level_error(inputs)
	if (locale === "ru") return ru_usage_level_error(inputs)
	if (locale === "it") return it_usage_level_error(inputs)
	return en_usage_level_error(inputs)
});